/**
 * Función utilitaria para obtener la URL de imagen según el formato de datos
 * Soporta tanto URLs directas como objetos imagesTitle
 */

export const getImageUrl = (item, size = 'medium') => {
  // Si item es una string directa (URL)
  if (typeof item === 'string') {
    if (item.startsWith('http')) {
      return item;
    } else {
      return `${process.env.REACT_APP_API_URL}${item}`;
    }
  }

  // Si item es un objeto con imageUrl
  if (item && item.imageUrl) {
    if (item.imageUrl.startsWith('http')) {
      return item.imageUrl;
    } else {
      return `${process.env.REACT_APP_API_URL}${item.imageUrl}`;
    }
  }

  // Si item es un objeto con imagesTitle
  if (item && item.imagesTitle) {
    const imageUrl = item.imagesTitle[size] || item.imagesTitle.medium || item.imagesTitle.original;
    if (imageUrl.startsWith('http')) {
      return imageUrl;
    } else {
      return `${process.env.REACT_APP_API_URL}${imageUrl}`;
    }
  }

  // Si item es un objeto con propiedades directas (medium, large, thumb, etc.)
  if (item && typeof item === 'object') {
    const imageUrl = item[size] || item.medium || item.original || item.large;
    if (imageUrl) {
      if (imageUrl.startsWith('http')) {
        return imageUrl;
      } else {
        return `${process.env.REACT_APP_API_URL}${imageUrl}`;
      }
    }
  }

  return ''; // Fallback
};

/**
 * Función para obtener la URL de imagen específica por tamaño
 */
export const getImageBySize = (item, size) => {
  return getImageUrl(item, size);
};

/**
 * Función para obtener la URL de imagen de fallback
 */
export const getFallbackImageUrl = (fallbackData) => {
  const fallbackImageUrl = fallbackData?.largeUrl || fallbackData?.originalUrl || fallbackData?.mediumUrl;
  if (fallbackImageUrl) {
    if (fallbackImageUrl.startsWith('http')) {
      return fallbackImageUrl;
    } else {
      return `${process.env.REACT_APP_API_URL}${fallbackImageUrl}`;
    }
  }
  return '';
};

/**
 * Función para obtener la URL de video
 * Soporta URLs directas y relativas
 */
export const getVideoUrl = (videoUrl) => {
  if (!videoUrl) return '';
  
  if (videoUrl.startsWith('http')) {
    return videoUrl;
  } else {
    return `${process.env.REACT_APP_API_URL}${videoUrl}`;
  }
};

/**
 * Función para obtener la URL de miniatura de video
 * Soporta URLs directas y relativas
 */
export const getVideoThumbnailUrl = (thumbnailUrl) => {
  if (!thumbnailUrl) return '';
  
  if (thumbnailUrl.startsWith('http')) {
    return thumbnailUrl;
  } else {
    return `${process.env.REACT_APP_API_URL}${thumbnailUrl}`;
  }
}; 